import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../i18n';
import { FaGlobe, FaCheck } from 'react-icons/fa';
import './LanguageSelector.css';

const LanguageSelector = () => {
    const { language, setLanguage, t } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const languages = [
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'es', name: 'Español', flag: '🇲🇽' },
        { code: 'pt', name: 'Português', flag: '🇧🇷' }
    ];

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLanguageChange = (langCode) => {
        setLanguage(langCode);
        setIsOpen(false);
    };

    const currentLang = languages.find(l => l.code === language);

    return (
        <div className="language-selector" ref={dropdownRef}>
            <button
                className="language-selector-btn"
                onClick={() => setIsOpen(!isOpen)}
                aria-label={t('language')}
            >
                <FaGlobe className="globe-icon" />
                <span className="current-lang">{currentLang?.flag} {currentLang?.code.toUpperCase()}</span>
            </button>

            {isOpen && (
                <div className="language-dropdown">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            className={`language-option ${language === lang.code ? 'active' : ''}`}
                            onClick={() => handleLanguageChange(lang.code)}
                        >
                            <span className="lang-flag">{lang.flag}</span>
                            <span className="lang-name">{lang.name}</span>
                            {language === lang.code && <FaCheck className="check-icon" />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;
